/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BaseReadConfigObject } from './BaseReadConfigObject';
import {
    BaseReadConfigObjectFromJSON,
    BaseReadConfigObjectFromJSONTyped,
    BaseReadConfigObjectToJSON,
} from './BaseReadConfigObject';

/**
 * 
 * @export
 * @interface BaseReadConfig
 */
export interface BaseReadConfig {
    /**
     * This is a map of object names to their configuration.
     * @type {{ [key: string]: BaseReadConfigObject; }}
     * @memberof BaseReadConfig
     */
    objects?: { [key: string]: BaseReadConfigObject; };
}

/**
 * Check if a given object implements the BaseReadConfig interface.
 */
export function instanceOfBaseReadConfig(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BaseReadConfigFromJSON(json: any): BaseReadConfig {
    return BaseReadConfigFromJSONTyped(json, false);
}

export function BaseReadConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): BaseReadConfig {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'objects': !exists(json, 'objects') ? undefined : (mapValues(json['objects'], BaseReadConfigObjectFromJSON)),
    };
}

export function BaseReadConfigToJSON(value?: BaseReadConfig | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'objects': value.objects === undefined ? undefined : (mapValues(value.objects, BaseReadConfigObjectToJSON)),
    };
}

